import { render, staticRenderFns } from "./UploadDocumentFromPC.vue?vue&type=template&id=78c4d88a&scoped=true&"
import script from "./UploadDocumentFromPC.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentFromPC.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocumentFromPC.vue?vue&type=style&index=0&id=78c4d88a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4d88a",
  null
  
)

export default component.exports